import React from 'react'
import { TranslateContextProvider } from 'client/common/translator'
import ZeroResults from 'client/fragments/listerFragment/components/ZeroResults'
import { ChakraProvider } from '@chakra-ui/react'
import { chemistryTheme } from 'chemistry'

export const NoResultsComponent = ({ collectionId, translations, term }) => {
  if (collectionId) return null // for collection page, maakk-fe responsible for message

  return (
    <ChakraProvider resetCSS={false} theme={chemistryTheme}>
      <TranslateContextProvider translations={translations}>
        <ZeroResults searchQuery={term} />
      </TranslateContextProvider>
    </ChakraProvider>
  )
}
